import React from "react";
import { ModalContext } from "@/app/context/Modals";

const useModals = () => {
    const { modal, setModal } = React.useContext(ModalContext);
    const closeModal = () => setModal(null)
    function openNewModal(newModal: JSX.Element | null) {
        setModal(prev=>newModal)
    }
    return { modal, openModal: openNewModal, closeModal };
}

export default useModals;